<div ngbDropdown #dropdown="ngbDropdown" class="notif-dropdown" [autoClose]="true" placement="bottom-end" (openChange)="onToggle($event)">
  <button class="bell-btn" aria-label="Notifications" ngbDropdownToggle>
    <svg class="bell-icon" [class.shake]="totalBadgeCount() > 0" width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
         stroke-linecap="round" stroke-linejoin="round">
      <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/>
      <path d="M13.73 21a2 2 0 0 1-3.46 0"/>
    </svg>
    @if (totalBadgeCount() > 0) {
      <span class="bell-badge">{{ totalBadgeCount() > 9 ? '9+' : totalBadgeCount() }}</span>
    }
  </button>

  <div ngbDropdownMenu class="dropdown-menu dropdown-menu-end shadow border-0 notif-menu">
    <div class="notif-head">
      <span class="notif-title">การแจ้งเตือน</span>
      @if (notificationService.unreadCount() > 0) {
        <button type="button" class="notif-readall" (click)="markAllRead($event)">
          อ่านทั้งหมด
        </button>
      }
    </div>

<!--    @if (pushService.isSupported() && !pushService.subscribed()) {-->
<!--      <button type="button" class="notif-enable" (click)="pushService.enable()">-->
<!--        <i class="bi bi-bell"></i>-->
<!--        <span>เปิดการแจ้งเตือนบนเบราว์เซอร์</span>-->
<!--      </button>-->
<!--    }-->

    @if (pendingInvitationCount() > 0) {
      <button type="button" class="notif-item unread" (click)="openRoleInvitations(dropdown)">
        <div class="d-flex align-items-center justify-content-between gap-2">
          <div class="notif-item-title">คำเชิญรับมอบสิทธิ์</div>
          <span class="notif-count-badge">{{ pendingInvitationCount() }}</span>
        </div>
        <div class="notif-item-body">มี {{ pendingInvitationCount() }} คำเชิญที่รอการตอบรับ</div>
      </button>
    }

    @if (notificationService.items().length === 0 && pendingInvitationCount() === 0) {
      <div class="notif-empty">ยังไม่มีการแจ้งเตือน</div>
    } @else {
      @for (n of notificationService.items(); track n.id) {
        <button type="button" class="notif-item" [class.unread]="!n.read" (click)="openNotification(n, dropdown)" (mouseenter)="markReadOnHover(n)">
          <div class="d-flex align-items-center justify-content-between gap-2">
            <div class="notif-item-title">{{ n.title }}</div>
            @if (n.type === 'ROLE_ASSIGNMENT') {
              <span class="badge bg-success-subtle text-success border border-success-subtle notif-type-badge">มอบสิทธิ์</span>
            } @else if (n.type === 'ROLE_ACCEPTED') {
              <span class="badge bg-primary-subtle text-primary border border-primary-subtle notif-type-badge">ตอบรับสิทธิ์</span>
            } @else if (n.type === 'ROLE_REJECTED') {
              <span class="badge bg-danger-subtle text-danger border border-danger-subtle notif-type-badge">ปฏิเสธสิทธิ์</span>
            }
          </div>
          @if (n.body) {
            <div class="notif-item-body">{{ n.body }}</div>
          }
        </button>
      }
    }
  </div>
</div>
